/**
 * Sticky Sections Handler
 * Asegura que las secciones marcadas como sticky funcionen correctamente
 * con posiciones top acumulativas basadas en alturas de secciones anteriores
 */

(function() {
  function calculateStickyPositions() {
    console.log('[Sticky] Iniciando cálculo de posiciones...');
    
    // En Shopify, cada sección con shopify-section-group-header-group ES una sección individual
    // No hay un contenedor padre, así que buscamos todas las secciones del header group directamente
    const sections = Array.from(document.querySelectorAll('.shopify-section-group-header-group'));
    
    console.log(`[Sticky] Total de secciones en header group: ${sections.length}`);
    
    if (sections.length === 0) {
      console.warn('[Sticky] No se encontraron secciones en el header group');
      return;
    }
    
    let accumulatedTop = 0;
    let zIndex = 10; // Max 10 para estar debajo de search (z-index: 20) y drawers (z-index: 30)
    let stickyCount = 0;
    
    sections.forEach((section, index) => {
      const stickyElement = section.querySelector('.sticky-section');
      
      if (stickyElement) {
        stickyCount++;
        
        // Aplicar sticky con z-index al section wrapper
        section.style.setProperty('position', 'sticky', 'important');
        section.style.setProperty('top', `${accumulatedTop}px`, 'important');
        section.style.setProperty('z-index', `${zIndex}`, 'important');
        
        // Aplicar z-index también al elemento interno sticky
        stickyElement.style.setProperty('z-index', `${zIndex}`, 'important');
        
        // Usar getBoundingClientRect para obtener altura exacta con decimales
        const exactHeight = section.getBoundingClientRect().height;
        
        console.log(`[Sticky] ✓ Sección ${index + 1} (${section.id}): top=${accumulatedTop}px, z-index=${zIndex}, altura=${exactHeight}px`);
        
        // Acumular la altura EXACTA de esta sección para la siguiente (sin redondear)
        accumulatedTop += exactHeight;
        zIndex--;
      } else {
        // Si la sección no es sticky, resetear el position
        section.style.position = '';
        section.style.top = '';
        section.style.zIndex = '';
        console.log(`[Sticky] ✗ Sección ${index + 1} (${section.id}): no sticky`);
      }
    });
    
    console.log(`[Sticky] ✅ Cálculo completado. Secciones sticky aplicadas: ${stickyCount} de ${sections.length}`);
  }
  
  function initStickySections() {
    console.log('[Sticky] Inicializando sticky sections...');
    
    // Calcular posiciones iniciales
    calculateStickyPositions();
    
    // Recalcular después de que todo cargue
    setTimeout(() => {
      console.log('[Sticky] Recalculando después de 500ms');
      calculateStickyPositions();
    }, 500);
    
    // Recalcular cuando la página termine de cargar
    window.addEventListener('load', () => {
      console.log('[Sticky] Página cargada, recalculando');
      setTimeout(calculateStickyPositions, 100);
    });
    
    // Recalcular en resize (debounced)
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        console.log('[Sticky] Resize detectado, recalculando');
        calculateStickyPositions();
      }, 250);
    });
  }
  
  // Inicializar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickySections);
  } else {
    initStickySections();
  }
  
  // Reinicializar en el theme editor
  if (window.Shopify && window.Shopify.designMode) {
    console.log('[Sticky] Modo editor detectado, activando listeners');
    
    document.addEventListener('shopify:section:load', () => {
      console.log('[Sticky] Section loaded');
      setTimeout(calculateStickyPositions, 100);
    });
    document.addEventListener('shopify:section:reorder', () => {
      console.log('[Sticky] Section reordered');
      setTimeout(calculateStickyPositions, 100);
    });
    document.addEventListener('shopify:section:select', () => {
      console.log('[Sticky] Section selected');
      setTimeout(calculateStickyPositions, 100);
    });
  }
})();

